import React, { Fragment } from 'react';
import EditModal from '../EditModal';
import KybDisplay from './KybDisplay';
import Heading from './Heading';
import useModal from '../../hooks/useModal';

export default function KybConfirmation({
  kyb,
  setRefreshKyb,
  onRevealSuccess,
  onRevealFail,
  submittedOnYourBehalf,
  token,
  raiseConfig,
  allowPhoneNumberUpdate,
}: {
  kyb: Kyb;
  setRefreshKyb: (refresh: symbol) => void;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  submittedOnYourBehalf: boolean;
  token: string;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  allowPhoneNumberUpdate?: boolean;
}): React.JSX.Element {
  const { isOpen, toggleModal } = useModal();

  return (
    <Fragment>
      <Heading submittedOnYourBehalf={submittedOnYourBehalf} />
      <EditModal
        isOpen={isOpen}
        onCancelClose={toggleModal}
        raiseConfig={raiseConfig}
      />
      <KybDisplay
        kyb={kyb}
        setRefreshKyb={setRefreshKyb}
        onEdit={toggleModal}
        onRevealSuccess={onRevealSuccess}
        onRevealFail={onRevealFail}
        token={token}
        allowPhoneNumberUpdate={allowPhoneNumberUpdate}
      />
    </Fragment>
  );
}
